import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "../basic/request-client.service";
import { UserClientService } from "../basic/user-client.service";
import { StringHelper } from "../../helpers/string.helper";
import type { EntityTypeConfigurationModel } from "../../components/comp-entity-finder/comp-entity-finder.models";

@autoinject
export class QueriesClientService {

    constructor(private requestClientService: RequestClientService, private userClientService: UserClientService) {
    }

    public getData(url: string, trackingId: string = null): Promise<any> {
        const promise = new Promise<any[]>((resolve, reject) => {

            const urlParts = url.split("?");

            let baseUrl = urlParts[0] + "/$query";

            if (trackingId) {
                baseUrl += "?tracking_id=" + trackingId;
            }

            this.requestClientService.post<any>(baseUrl, {}, urlParts[1] || "")
                .then((result: any) => {
                    if (result.value && result.value[0] &&
                        result.value[0]["groupedResult"]) {
                        if (result.value[0] && !result.value[0].dynamicProperties) {
                            delete result.value[0].dynamicProperties;
                        }
                        if (result.value[0]["groupedResult"].length > 0) {
                            result.value[0]["groupedResult"].forEach(x => {
                                result.value[0][x["key"]] = x["data"];
                            });
                        }

                        delete result.value[0]["groupedResult"];
                    }
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    public odataModelToString(filter: string, format: string | ((filter: string, item: any, isAuthenticated: boolean, isFilter: boolean) => string), 
        properties: string, config: EntityTypeConfigurationModel, item, isFilter: boolean = false): string {

        if (!item) {
            return null;
        }

        let propertiesArray = properties ? properties.split(',') : null;

        if (!item) {
            return null;
        }

        let finalFormat = typeof format == "function" ? format(filter, item, !!this.userClientService.currentUser, isFilter) : format;

        if (config && (!format || format == "")) {
            if (config.format && typeof config.format === "string") {
                finalFormat = config.format;
            } else if (config.format && typeof config.format === "function") {
                finalFormat = config.format(filter, item, !!this.userClientService.currentUser, isFilter);
            } else {
                finalFormat = "{0}";
            }
        }
        if (config && config.properties && (!properties || properties == "")) {
            propertiesArray = config.properties.split(',');
        }
        if (propertiesArray && propertiesArray.length > 0) {
            for (let i = 0; i < propertiesArray.length; i++) {
                const index = "{" + i + "}";
                const regex = new RegExp(StringHelper.escapeRegExp(index), 'g');
                const str = item[propertiesArray[i]];
                finalFormat = finalFormat.replace(regex, str ? str : "");
            }
        }

        return this.decode(item && Object.keys(item).length !== 0 ? finalFormat : "");
    }

    decode(text: string) {
        const decoded = $('<div/>').html(text).get(0).innerHTML;
        return decoded || null;
    }
}
